// Module
var code = `<div class="row">
	<amt-form-inline
		name='restore.RestoreForm'
		on-submit='start(model)'
		options='{supressPropertyTitles: true}'
	></amt-form-inline>
</div>

<button ng-click="delete_all_restore_tables()">Delete all temporary tables</button>

<div ng-repeat="(task_id, task) in tasks">
	<h3>Task ID: {{task_id}}</h3>
	<b>Created: {{task.create_datetime}}</b><br/>
    <b>Started: {{task.start_datetime}}</b><br/>
	<b>From: {{task.from_datetime}}</b><br/>
	<b>To: {{task.to_datetime}}</b><br/>
    <b>Topic: {{ task.topic }}</b><br/>
    <b>tables_list: {{task.tables_list}}</b><br/>
    <h4>Status: {{task.status}}</h4><br/>
    <button ng-click="consume_events(task_id)">Consume events</button>
    <button ng-click="delete_task(task_id)">Delete task</button>
	<!--<b>Select batch: {{task.request_batch}}</b><br/>-->
	<!--<b>Insert batch: {{task.insert_batch}}</b><br/>-->
    <!--<b ng-if="table.error">Error: {{table.error}}</b>-->
    <h4>Tables</h4>
	<div ng-repeat="(table_name, count) in task.tables">
        <b>{{table_name}}: {{ count }}</b>
	</div>
</div>
`;
// Exports
module.exports = code;